// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--27wbx","fullWidth":"Card-module--fullWidth--3z_UM","md":"Card-module--md--1AG-5","sm":"Card-module--sm--WCaca"};